import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

import { styled } from 'styled-system/jsx'

const PageStack = styled(motion.div, {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
})

const HeroBlock = styled(motion.div, {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    paddingX: '4px',
    paddingY: '12px',
  },
})

const Greeting = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '36px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-1px',
  },
})

const GreetingSubtitle = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '17px',
    color: 'quickpass.inkSoft',
    margin: '0',
  },
})

const QuickActionsGrid = styled(motion.div, {
  base: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: '12px',
  },
})

const QuickActionCard = styled(Link, {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '20px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    boxShadow: '0 12px 32px -16px rgba(128, 84, 255, 0.15)',
    border: '1.5px solid transparent',
    color: 'inherit',
    textDecoration: 'none',
    cursor: 'pointer',
    transition:
      'transform {durations.fast} {easings.appleStandard}, border-color {durations.fast} {easings.appleStandard}, box-shadow {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
      transform: 'translateY(-2px)',
      boxShadow: '0 18px 38px -16px rgba(128, 84, 255, 0.32)',
    },
  },
})

const QuickActionEmoji = styled('span', {
  base: {
    fontSize: '24px',
    lineHeight: '1',
  },
})

const QuickActionTitle = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '17px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const QuickActionSubtitle = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    lineHeight: '1.4',
  },
})

const SectionHeader = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    paddingX: '4px',
  },
})

const SectionTitle = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '22px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.5px',
  },
})

const SectionLink = styled(Link, {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.primary',
    textDecoration: 'none',
    cursor: 'pointer',
    _hover: {
      textDecoration: 'underline',
      textUnderlineOffset: '3px',
    },
  },
})

const EmptyState = styled('div', {
  base: {
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    padding: '32px',
    textAlign: 'center',
    border: '1.5px dashed',
    borderColor: '#E5E0F5',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
  },
})

const EmptyEmoji = styled('span', {
  base: {
    fontSize: '40px',
    lineHeight: '1',
  },
})

const EmptyTitle = styled('p', {
  base: {
    fontFamily: 'display',
    fontSize: '18px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
  },
})

const EmptyBody = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
    margin: '0',
    maxWidth: '420px',
    lineHeight: '1.5',
  },
})

const PreferencesGrid = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
    gap: '16px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    padding: '20px',
    boxShadow: '0 12px 32px -16px rgba(128, 84, 255, 0.12)',
  },
})

const PreferenceCell = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
})

const PreferenceLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
})

const PreferenceValue = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    fontWeight: '600',
    color: 'quickpass.ink',
  },
})

export {
  PageStack,
  HeroBlock,
  Greeting,
  GreetingSubtitle,
  QuickActionsGrid,
  QuickActionCard,
  QuickActionEmoji,
  QuickActionTitle,
  QuickActionSubtitle,
  SectionHeader,
  SectionTitle,
  SectionLink,
  EmptyState,
  EmptyEmoji,
  EmptyTitle,
  EmptyBody,
  PreferencesGrid,
  PreferenceCell,
  PreferenceLabel,
  PreferenceValue,
}
